export class GisQureyResult {
  tipo: string;
  id: number;
  titolo: string;
  geom: string;
  /**
   *
   */
  constructor() { }
}